import React from 'react';
// import { ReactTypeformEmbed } from 'react-typeform-embed';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import AssessmentCard from './assessment-card'
import ChevronRight from 'mdi-react/ChevronRightIcon';
import ChevronLeft from 'mdi-react/ChevronLeftIcon';
import TypeformView from '../TypeformView'
import $ from 'jquery';
import uuid from 'uuid';
import { signout } from '../../../redux/actions/userActions';
import '../../../scss/component/assessments/profile-assessment.scss'

import DataLoader from '../../../app/DataLoader'
const stepOneImg = process.env.PUBLIC_URL + '/img/default-typeform.png'
const stepTwoImg = process.env.PUBLIC_URL + '/img/stepTwoForm.png'
const stepThreeImg = process.env.PUBLIC_URL + '/img/stepThreeForm.png'
const stepFourImg = process.env.PUBLIC_URL + '/img/stepFourForm.png'

class CompAssessment extends React.Component {
    state = {
        categoryIndex: 0,
        isActive: true,
        hoverColor: true,
        bgColr: "white-bg",
        loading: true,
        loaded: false,
        updateForm: true,
        forms: []
    }

    scrollContent (direction) {
        const step = 370;

        $("#card-content").animate({
            scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
        });
    }

    componentDidMount () {
        const tenantId = localStorage.getItem('tenant')
        let forms

        if(["prod"].includes(process.env.REACT_APP_ENV)){
            forms = [
                {
                    name: 'Details',
                    url: `https://postured.typeform.com/to/bO1DhL?tenantid=${tenantId}&assessmentid=1`,
                    description: 'Step 1',
                    img: stepOneImg,
                    width: '80px',
                    height: '60px'
                },
                {
                    name: 'Data',
                    url: `https://postured.typeform.com/to/YTTju6?tenantid=${tenantId}&assessmentid=2`,
                    description: 'Step 2',
                    img: stepTwoImg,
                    width: '80px',
                    height: '60px'
                },
                /*{
                    name: 'Compliance',
                    url: `https://postured.typeform.com/to/oJXUTB?tenantid=${tenantId}&assessmentid=3` +
                        `&frameworkname=hipaa&frameworkid=4`,

                    description: 'Step 3',
                    img: stepThreeImg,
                    width: '70px',
                    height: '50px'
                }*/
            ]
        }
        else{
            forms = [
                {
                    name: 'Details',
                    url: `https://postured.typeform.com/to/cneUiymG?tenantid=${tenantId}&assessmentid=1`,
                    description: 'Step 1',
                    img: stepOneImg,
                    width: '80px',
                    height: '60px'
                },
                {
                    name: 'Data',
                    url: `https://postured.typeform.com/to/VGtROHlf?tenantid=${tenantId}&assessmentid=2`,
                    description: 'Step 2',
                    img: stepTwoImg,
                    width: '80px',
                    height: '60px'
                },
                /*{
                    name: 'Compliance',
                    url: `https://postured.typeform.com/to/WnQOQVK1?tenantid=${tenantId}&assessmentid=3` +
                        `&frameworkname=hipaa&frameworkid=4`,

                    description: 'Step 3',
                    img: stepThreeImg,
                    width: '70px',
                    height: '50px'
                }*/
            ]            
        }
            

        this.setState({ forms: forms })
    }

    setUpdate = (title, active) => {
        this.setState({ updateForm: (title !== active) })
    }

    selectNewCatagory (category) {
        this.setState({ categoryIndex: category });
    }

    render () {
        return (
            <DataLoader>
                <div className="comp-assessment">
                    <div>
                        <Row>
                            <Col md={12} id="test" style={{
                                    marginLeft: "5%",
                                }}>
                                <h3 className='page-title'>Company Profile Assessment</h3>
                                <h3 className='page-subhead subhead'>
                                    Determine the state of your company's compliance health</h3>
                            </Col>
                        </Row>
                        <Row className="assessment-card-row">
                            <div className="arrow-left">
                                <div
                                    className='nvaigation-style'
                                    onClick={() => this.scrollContent('left')}>
                                    <ChevronLeft id='scrollUp' size={60} color={'#C6C6C6'} />
                                </div>
                            </div>
                                <div id="card-content">
                                    {this.state.forms.map((form, idx) => {
                                        return (
                                            <div key={uuid()} >
                                                <div className="staticComplianceCard">
                                                    <AssessmentCard
                                                        categoryIndex={this.state.categoryIndex}
                                                        id={idx}
                                                        category={form.name}
                                                        description={form.description}
                                                        changeCategory={this.selectNewCatagory.bind(this)}
                                                        clickable={true}
                                                        hoverColor={true}
                                                        isActive={this.state.categoryIndex === idx ? true : false}
                                                        bgColor="white-bg"
                                                        isPercentage={false}
                                                        img={form.img}
                                                        imgWidth={form.width}
                                                        imgHeight={form.height}
                                                        setUpdate={this.setUpdate}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                    )}
                                </div>
                            <div className="arrow-right">
                                <div
                                    className='nvaigation-style'
                                    onClick={() => this.scrollContent('right')}>
                                    <ChevronRight id='scrollDown' size={60} color={'#C6C6C6'} />
                                </div>
                            </div>
                        </Row>

                    </div>

                    {
                        this.state.forms.map((category, idx) => {
                            return <div key={uuid()}><TypeformView
                                categoryIndex={this.state.categoryIndex}
                                i={idx}
                                url={`${category.url}`+
                                `&tenantname=${this.props.tenant ? this.props.tenant.companyName: ""}`} /></div>
                        }
                        )
                    }
                </div >
            </DataLoader>
        )
    }
}

function mapStateToProps (state) {
    return {
        user: state.auth.user,
        tenant: state.auth.tenant,
        enabledFrameworks: state.controlsData.enabledFrameworks,
        dataLoaded: !state.controlsData.loading,
        sidebar: state.sidebar
    }
}

export default connect(mapStateToProps, { signout })(withRouter(CompAssessment))


// WEBPACK FOOTER //
// ./src/components/assessment/components/ProfileAssessment.js